import * as am4charts from '@amcharts/amcharts4/charts';
import * as am4core from '@amcharts/amcharts4/core';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  Input,
  NgZone,
  PLATFORM_ID,
  SimpleChanges,
} from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import * as Pyramid from '../../../../assets/Pyramid.json';
import { PersonalProcess } from '../../model/performance.model';
import { PerformanceService } from '../../services/performance.service';

@Component({
  selector: 'ara-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css'],
})
export class ChartComponent {
  @Input() moduleValue: string = '';
  @Input() data: any;
  private chart: am4charts.XYChart;
  leaderYTD: any[] = [];
  pyramidData: string[] = [];
  isShowZoomOut: boolean = true;
  transposedData: any[] = [];
  DataFound: boolean = true;

  constructor(
    @Inject(PLATFORM_ID) private platformId,
    private zone: NgZone,
    private PDService: PerformanceService,
    private baseService: BaseService,
  ) {
    //this.getLeaderData();
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    this.DataFound = true;
    if (!this.data || this.data == null || this.data.length === 0) {
      this.DataFound = false;
      return;
    }
    if (this.moduleValue) {
      //this.getLeaderData();
      switch (this.moduleValue) {
        case 'Leaderboard Dashboard':
          if (this.data && this.data.personalData)
            if (this.data.personalData.length && this.data.processData.length) {
              this.pyramidChart();
            }
          break;
        case 'QHSSE KPI':
          this.clusteredColumnChart();
          break;
        case 'Action Tracker':
        case 'Observation Type':
        case 'Safety Observation':
        case 'Action Priority':
        // case 'Waste Consumption':
        // case 'Incident Type':
        case 'Observation Action':
        // case 'Inspection Type':
        // case 'Observation Category':
        // case 'Incident Category':
        case 'Training Status':
          if (this.data)
            if (this.data.length && this.data.length) {
              this.clusteredColumnChart();
            }
          break;
        case 'Energy Consumption':
        case 'Waste Consumption':
        case 'Incident High Potential':
        case 'Man Hour Calculation':
        case 'Head Count':
        case 'Observation Category':
        case 'Incident Category':
        case 'Inspection Type':
        case 'Incident Type':
          if (this.data)
            if (this.data.length && this.data.length) {
              this.stackedColumnChart();
            }
          break;
        // case 'Waste Consumption':
        //   if (this.data)
        //     if (this.data.length && this.data.length) {
        //       this.clusteredColumnChart();
        //     }
        //   break;
        case 'Training Compliance Summary':
          if (this.data)
            if (this.data.length && this.data.length) {
              this.PieChart();
            }
          break;
        default:
          this.pyramidChart();
      }
    }
  }

  // Run the function only in the browser
  browserOnly(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }

  ngAfterViewInit() {
    // Chart code goes in here
    this.browserOnly(() => {
      am4core.useTheme(am4themes_animated);
    });
  }

  ngOnDestroy() {
    // Clean up chart when the component is removed
    this.browserOnly(() => {
      if (this.chart) {
        this.chart.dispose();
      }
    });
  }

  pyramidChart() {
    this.isShowZoomOut = false;
    // let personalValues = JSON.parse(this.baseService.getItemFromSession('personalData'));
    // let processValues = JSON.parse(this.baseService.getItemFromSession('processData'));

    let personalValues = this.data.personalData;
    let processValues = this.data.processData;

    let pyramidTemplate = JSON.stringify(
      Pyramid.template
        .replace('@Fatalities', personalValues[7].YTD.toString())
        .replace('@LTI', personalValues[6].YTD.toString())
        .replace('@Injuries', personalValues[5].YTD.toString())
        .replace('@OccupationalIllness', personalValues[4].YTD.toString())
        .replace('@PersonalNear', personalValues[3].YTD.toString())
        .replace('@LifeSavingRules', personalValues[2].YTD.toString())
        .replace('@Observations', personalValues[1].YTD.toString())
        .replace('@Managementvisits', personalValues[0].YTD.toString())
        .replace('@Tier1HC', processValues[4].YTD.toString())
        .replace('@Tier2HC', processValues[3].YTD.toString())
        .replace('@Tier3', processValues[2].YTD.toString())
        .replace('@HighPotentials', processValues[1].YTD.toString())
        .replace('@ProcessNear', processValues[0].YTD.toString()),
    );
    //pyramidTemplate.replace("@tier1Value","5");
    let element = <HTMLInputElement>document.getElementById('chartdiv');
    element.innerHTML = pyramidTemplate.replace(/^\"+|\"+$/g, '');
  }

  clusteredColumnChart() {
    this.isShowZoomOut = true;

    let chart = am4core.create('chartdiv', am4charts.XYChart);
    //  chart.maxWidth=200;
    //  chart.width=200;

    chart.colors.step = 2;
    //chart.wheelable = true;
    chart.legend = new am4charts.Legend();
    chart.legend.position = 'top';
    chart.legend.paddingBottom = 5;
    chart.responsive.enabled = true;
    chart.colors.list = [
      am4core.color('#ac1e2e'),
      //am4core.color("#D65DB1"),
      am4core.color('#FF6F91'),
      am4core.color('#FF9671'),
      am4core.color('#FFC75F'),
      am4core.color('#F9F871'),

      am4core.color('#404e7b'),
      //am4core.color("#91aa3a"),
      am4core.color('#e6cc33'),
      am4core.color('#e66933'),
      am4core.color('#f40839'),
      //am4core.color("#15ff00"),
      am4core.color('#faebd7'),
      //New List
      // am4core.color("#FF0000"),
      // am4core.color("#00FFFF"),
      // am4core.color("#0000FF"),
      // am4core.color("#00008B"),
      // am4core.color("#ADD8E6"),
      // am4core.color("#800080"),

      am4core.color('#FFFF00'),
      // am4core.color("#00FF00"),
      // am4core.color("#FF00FF"),
      // am4core.color("#FFC0CB"),
      // am4core.color("#C0C0C0"),
      am4core.color('#000000'),

      am4core.color('#FFA500'),
      am4core.color('#800000'),
      // am4core.color("#808000"),
      am4core.color('#98AFC7'),
      //New List

      am4core.color('#765757'),
      am4core.color('#258883'),
      am4core.color('#c230b4'),
      //am4core.color("#7c7c7c"),
      //am4core.color("#868e1a"),
      //am4core.color("#25592c"),
      //am4core.color("#C0F312"),
      //am4core.color("#73A16C"),
    ];

    chart.cursor = new am4charts.XYCursor();

    //chart.scrollbarX = new am4core.Scrollbar();

    // let home = chart.chartContainer.createChild(am4core.Button);
    // home.label.text = "Home";
    // home.align = "right";
    // home.events.on("hit", function(ev) {
    //   chart.zoomToIndexes(1,2);
    // });

    let xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    xAxis.dataFields.category = 'category';
    xAxis.renderer.cellStartLocation = 0.1;
    xAxis.renderer.cellEndLocation = 0.9;
    xAxis.renderer.grid.template.location = 0;
    xAxis.renderer.labels.template.rotation = -90;
    xAxis.maxZoomCount = 3;

    let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
    yAxis.min = 0;
    yAxis.axisFullLength = 150;

    // Enable Export
    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.align = 'left';
    chart.exporting.menu.verticalAlign = 'top';

    function createSeries(value, name) {
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = value;
      series.dataFields.categoryX = 'category';
      series.name = name;
      // series.columns.template.width = am4core.percent(700);

      //series.events.on('hidden', arrangeColumns);
      //series.events.on('shown', arrangeColumns);

      let bullet = series.bullets.push(new am4charts.LabelBullet());
      bullet.interactionsEnabled = false;
      bullet.dy = -10;
      bullet.label.text = '{valueY}';
      bullet.label.fill = am4core.color('black');

      return series;
    }

    if (this.moduleValue == 'Incident Type') {
      if (this.data[0].Rows && this.data[0].Rows.length) {
        chart.data = this.data[0].Rows;
        this.data[0].Rows.forEach((element) => {
          if (element[0] != 'Total') element.category = element[0];
        });
      }
    }

    if (this.moduleValue == 'Inspection Type') {
      if (this.data[0].Rows && this.data[0].Rows.length) {
        chart.data = this.data[0].Rows;
        this.data[0].Rows.forEach((element) => {
          if (element[0] != 'Total') element.category = element[0];
        });
      }
    }

    if (this.moduleValue == 'Observation Category') {
      if (this.data[0].Rows && this.data[0].Rows.length) {
        chart.data = this.data[0].Rows;
        this.data[0].Rows.forEach((element) => {
          if (element[1] != 'Total') element.category = element[1];
        });
      }
    }

    if (this.moduleValue == 'Incident Category') {
      if (this.data[0].Rows && this.data[0].Rows.length) {
        chart.data = this.data[0].Rows;
        this.data[0].Rows.forEach((element) => {
          if (element[1] != 'Total') element.category = element[1];
        });
      }
    }

    if (this.moduleValue == 'Training Status') {
      if (this.data[0].Rows && this.data[0].Rows.length) {
        chart.data = this.data[0].Rows;
        this.data[0].Rows.forEach((element) => {
          if (element[1] != 'Total') element.category = element[1];
        });
      }
    }

    if (
      this.moduleValue !== 'Incident Type' &&
      this.moduleValue !== 'Inspection Type' &&
      this.moduleValue !== 'Observation Category' &&
      this.moduleValue !== 'Incident Category' &&
      this.moduleValue !== 'Training Status'
    ) {
      chart.data = [...this.data];
    }

    switch (this.moduleValue) {
      case 'Action Tracker':
        chart.data.pop();
        createSeries('Open', 'Open');
        createSeries('Done', 'Done');
        createSeries('Closed', 'Closed');
        createSeries('Accepted', 'Accepted');
        createSeries('PassedDueDate', 'Passed Due Date');
        break;
      case 'Safety Observation':
        createSeries('Jan', 'Jan');
        createSeries('Feb', 'Feb');
        createSeries('Mar', 'Mar');
        createSeries('Apr', 'Apr');
        createSeries('May', 'May');
        createSeries('Jun', 'Jun');
        createSeries('Jul', 'Jul');
        createSeries('Aug', 'Aug');
        createSeries('Sep', 'Sep');
        createSeries('Oct', 'Oct');
        createSeries('Nov', 'Nov');
        createSeries('Dec', 'Dec');
        break;
      case 'Observation Type':
        chart.data.pop();
        createSeries('Conversation', 'Conversation');
        createSeries('Safe', 'Safe');
        createSeries('Act', 'Act');
        createSeries('Observation', 'Observation');
        createSeries('Unsafe', 'Unsafe');
        createSeries('Condition', 'Condition');
        break;
      case 'Action Priority':
        chart.data.pop();
        createSeries('Low', 'Low');
        createSeries('Medium', 'Medium');
        createSeries('High', 'High');
        break;
      // case 'Waste Consumption':
      //   //chart.data.pop();
      //   createSeries('Jan', 'Hazardous Waste Oil');
      //   createSeries('Feb', 'Hazardous Waste Chemical');
      //   createSeries('Mar', 'Hazardous Waste Drilling');
      //   createSeries('Apr', 'Hazardous Waste Other');
      //   createSeries('May', 'Non Hazard Scrap');
      //   createSeries('Jun', 'Non Hazard Wood');
      //   createSeries('Jul', 'Non Hazard Plastic');
      //   createSeries('Aug', 'Non Hazard Domestic');
      //   createSeries('Sep', 'Non Hazard Kitchen');
      //   createSeries('Oct', 'Sewage Water');
      //   createSeries('Nov', 'OBM Disposed');
      //   createSeries('Dec', 'Number Of Consignment Note');
      //   break;
      case 'Incident Type':
        if (this.data[0].Headers && this.data[0].Rows) {
          this.data[0].Headers.forEach((element, index) => {
            if (index > 0 && this.data[0].Headers[index] !== 'UnitId') {
              createSeries(index, this.data[0].Headers[index]);
            }
          });
        }
        break;
      case 'Inspection Type':
        if (this.data[0].Headers && this.data[0].Rows) {
          this.data[0].Headers.forEach((element, index) => {
            if (index > 0 && this.data[0].Headers[index] !== 'UnitId') {
              createSeries(index, this.data[0].Headers[index]);
            }
          });
        }
        break;
      case 'Observation Category':
        if (this.data[0].Headers && this.data[0].Rows) {
          this.data[0].Headers.forEach((element, index) => {
            if (index > 0 && this.data[0].Headers[index] !== 'Location') {
              createSeries(index, this.data[0].Headers[index]);
            }
          });
        }
        break;
      case 'Incident Category':
        if (this.data[0].Headers && this.data[0].Rows) {
          this.data[0].Headers.forEach((element, index) => {
            if (index > 0 && this.data[0].Headers[index] !== 'Unit') {
              createSeries(index, this.data[0].Headers[index]);
            }
          });
        }
        break;
      case 'Training Status':
        if (this.data[0].Headers && this.data[0].Rows) {
          this.data[0].Headers.forEach((element, index) => {
            if (index > 0 && this.data[0].Headers[index] !== 'Unit Name') {
              createSeries(index, this.data[0].Headers[index]);
            }
          });
        }
        break;

      case 'Observation Action':
        chart.data.pop();
        createSeries('WithAction', 'Observation With Action');
        createSeries('WithoutAction', 'Observation Without Action');
        break;
      default:
        createSeries('First', 'First');
        createSeries('Second', 'Second');
        this.data = [
          {
            category: 'Unit1',
            First: 40,
            Second: 55,
          },
          {
            category: 'Unit2',
            First: 40,
            Second: 55,
          },
        ];
        break;
    }

    function arrangeColumns() {
      let series = chart.series.getIndex(0);

      let w =
        1 -
        xAxis.renderer.cellStartLocation -
        (1 - xAxis.renderer.cellEndLocation);
      if (series.dataItems.length > 1) {
        let x0 = xAxis.getX(series.dataItems.getIndex(0), 'categoryX');
        let x1 = xAxis.getX(series.dataItems.getIndex(1), 'categoryX');
        let delta = ((x1 - x0) / chart.series.length) * w;
        if (am4core.isNumber(delta)) {
          let middle = chart.series.length / 2;

          let newIndex = 0;
          chart.series.each(function (series) {
            if (!series.isHidden && !series.isHiding) {
              series.dummyData = newIndex;
              newIndex++;
            } else {
              series.dummyData = chart.series.indexOf(series);
            }
          });
          let visibleCount = newIndex;
          let newMiddle = visibleCount / 2;

          chart.series.each(function (series) {
            let trueIndex = chart.series.indexOf(series);
            let newIndex = series.dummyData;

            let dx = (newIndex - trueIndex + middle - newMiddle) * delta;

            series.animate(
              { property: 'dx', to: dx },
              series.interpolationDuration,
              series.interpolationEasing,
            );
            series.bulletsContainer.animate(
              { property: 'dx', to: dx },
              series.interpolationDuration,
              series.interpolationEasing,
            );
          });
        }
      }
    }
  }

  stackedColumnChart() {
    this.isShowZoomOut = true;
    // Create chart instance
    let chart = am4core.create('chartdiv', am4charts.XYChart);

    chart.cursor = new am4charts.XYCursor();
    if (
      this.moduleValue == 'Observation Category' ||
      this.moduleValue == 'Incident Category' ||
      this.moduleValue == 'Inspection Type' ||
      this.moduleValue == 'Incident Type'
    ) {
      chart.cursor.maxTooltipDistance = -1;
      chart.colors.list = [
        am4core.color('#ac1e2e'),
        am4core.color('#FF6F91'),
        am4core.color('#FF9671'),
        am4core.color('#FFC75F'),
        am4core.color('#F9F871'),

        am4core.color('#404e7b'),
        am4core.color('#e6cc33'),
        am4core.color('#e66933'),
        am4core.color('#f40839'),
        am4core.color('#faebd7'),

        am4core.color('#FFFF00'),
        am4core.color('#000000'),

        am4core.color('#FFA500'),
        am4core.color('#800000'),
        am4core.color('#98AFC7'),
        //New List

        am4core.color('#765757'),
        am4core.color('#258883'),
        am4core.color('#c230b4'),
      ];
    }
    chart.scrollbarX = new am4core.Scrollbar();

    // Add data
    chart.data = [...this.data];
    chart.data.pop();

    // Create axes
    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'category';
    categoryAxis.renderer.grid.template.location = 0;
    if (
      this.moduleValue == 'Observation Category' ||
      this.moduleValue == 'Incident Category' ||
      this.moduleValue == 'Inspection Type' ||
      this.moduleValue == 'Incident Type'
    ) {
      categoryAxis.renderer.labels.template.rotation = 75;
      categoryAxis.renderer.labels.template.verticalCenter = 'middle';
      categoryAxis.renderer.labels.template.horizontalCenter = 'left';
      categoryAxis.renderer.minGridDistance = 30;
    } else {
      categoryAxis.renderer.labels.template.rotation = -45;
    }

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.inside = true;
    valueAxis.renderer.labels.template.disabled = true;
    valueAxis.min = 0;
    if (
      this.moduleValue == 'Observation Category' ||
      this.moduleValue == 'Incident Category' ||
      this.moduleValue == 'Inspection Type' ||
      this.moduleValue == 'Incident Type'
    ) {
      valueAxis.extraMax = 0.1;
      valueAxis.calculateTotals = true;
    } else {
      valueAxis.calculateTotals = false;
    }

    // Create series
    function createSeries(field, name, moduleValue) {
      // Set up series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.name = name;
      series.dataFields.valueY = field;
      series.dataFields.categoryX = 'category';
      series.sequencedInterpolation = true;

      // Make it stacked
      series.stacked = true;

      // Configure columns
      series.columns.template.width = am4core.percent(60);
      // series.columns.template.tooltipText =
      // '[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}';
      series.tooltipText =
        '[bold]{name}[/]\n[font-size:12px]{categoryX}: {valueY}';
      series.tooltipY = am4core.percent(0);

      // Add label
      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.label.text = '{valueY}';
      labelBullet.locationY = 0.5;
      labelBullet.label.hideOversized = true;

      //  labelBullet.label.adapter.add("textOutput", function (text, target) {
      //    if (target.dataItem && text == '0') //valueX or valueY based on your data
      //      return "";
      //    return text;
      //   });

      if (
        moduleValue != 'Observation Category' &&
        moduleValue != 'Incident Category' &&
        moduleValue != 'Inspection Type' &&
        moduleValue != 'Incident Type'
      ) {
        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.name = name;
        lineSeries.dataFields.valueY = field;
        lineSeries.dataFields.categoryX = 'category';

        //lineSeries.stroke = am4core.color('#fdd400');
        lineSeries.strokeWidth = 2;
        lineSeries.propertyFields.strokeDasharray = 'lineDash';
        lineSeries.tooltip.label.textAlign = 'middle';
        lineSeries.stacked = true;
        lineSeries.zIndex = 10;

        lineSeries.hiddenInLegend = true;
      }

      return series;
    }

    switch (this.moduleValue) {
      case 'Energy Consumption':
        createSeries(
          'NaturalGasProd',
          'Total Gas Production',
          this.moduleValue,
        );
        createSeries(
          'FuelGasGenerators',
          'Fuel Gas - Generators',
          this.moduleValue,
        );
        createSeries(
          'FuelGasTreater',
          'Fuel Gas - Heater Treater',
          this.moduleValue,
        );
        createSeries('AllGasFlared', 'All Gas Flared', this.moduleValue);
        createSeries(
          'TotalProducedWater',
          'Total Produced Water',
          this.moduleValue,
        );
        createSeries('PWReInjected', 'PW Re-Injected', this.moduleValue);
        createSeries('PWEvaporated', 'PW Evaporated', this.moduleValue);
        createSeries(
          'WaterAbstracted',
          'Water Abstracted for Water Injection',
          this.moduleValue,
        );
        createSeries('EPFDGS', 'EPF DGS', this.moduleValue);
        createSeries('CampDGS', 'Camp DGS', this.moduleValue);
        createSeries('ContractorDGS', 'Contractor DGS', this.moduleValue);
        createSeries('Vehicle', 'Vehicle', this.moduleValue);
        createSeries(
          'StationarySource',
          'Stationary Sources',
          this.moduleValue,
        );
        createSeries('Generators', 'Generators', this.moduleValue);
        createSeries('Other', 'Other', this.moduleValue);
        createSeries('WellsDGS', 'Wells', this.moduleValue);
        createSeries('WaterConsumption', 'Consumption', this.moduleValue);
        break;
      case 'Waste Consumption':
        createSeries(
          'HazardousWasteOily',
          'Hazardous Waste Oil',
          this.moduleValue,
        );
        createSeries(
          'HazardousWasteChemical',
          'Hazardous Waste Chemical',
          this.moduleValue,
        );
        createSeries(
          'HazardousWasteDrilling',
          'Hazardous Waste Drilling',
          this.moduleValue,
        );
        createSeries(
          'HazardousWasteOther',
          'Hazardous Waste Other',
          this.moduleValue,
        );
        createSeries('NonHazardScrap', 'Non Hazard Scrap', this.moduleValue);
        createSeries('NonHazardWood', 'Non Hazard Wood', this.moduleValue);
        createSeries(
          'NonHazardPlastic',
          'Non Hazard Plastic',
          this.moduleValue,
        );
        createSeries(
          'NonHazardDomestic',
          'Non Hazard Domestic',
          this.moduleValue,
        );
        createSeries(
          'NonHazardKitchen',
          'Non Hazard Kitchen',
          this.moduleValue,
        );
        createSeries('SewageWater', 'Sewage Water', this.moduleValue);
        createSeries('OBMDisp', 'OBM Disposed', this.moduleValue);
        createSeries(
          'NumOfConsignmentNote',
          'Number Of Consignment Note',
          this.moduleValue,
        );
        break;
      case 'Incident High Potential':
        createSeries('Yes', 'Yes', this.moduleValue);
        createSeries('No', 'No', this.moduleValue);
        break;
      case 'Man Hour Calculation':
        chart.data.pop();
        createSeries('StaffHours', 'Staff Hours', this.moduleValue);
        createSeries('ContractorHours', 'Contractor Hours', this.moduleValue);
        break;
      case 'Head Count':
        chart.data.pop();
        createSeries('StaffCount', 'Staff Count', this.moduleValue);
        createSeries('ContractorCount', 'Contractor Count', this.moduleValue);
        break;
      case 'Observation Category':
      case 'Incident Category':
      case 'Inspection Type':
      case 'Incident Type':
        let trans = [];
        if (this.data[0].Headers) {
          trans.push(this.data[0].Headers);
        }
        if (this.data[0].Rows) {
          this.data[0].Rows.forEach((element) => {
            trans.push(element);
          });
        }
        this.TransposeData(trans);
        if (trans && trans.length > 0 && this.transposedData) {
          const transposedArray = Object.values(this.transposedData);
          chart.data = transposedArray;
          switch (this.moduleValue) {
            case 'Observation Category':
              transposedArray[1].forEach((Name, index) => {
                if (index > 0) {
                  createSeries(index, Name, this.moduleValue);
                }
              });
              transposedArray.forEach((element) => {
                if (
                  element[0] !== 'LocationId' &&
                  element[0] !== 'Location' &&
                  element[0] !== 1
                ) {
                  element.category = element[0].split('#')[0];
                }
              });
              break;
            case 'Incident Category':
              transposedArray[1].forEach((Name, index) => {
                if (index > 0) {
                  createSeries(index, Name, this.moduleValue);
                }
              });
              transposedArray.forEach((element) => {
                if (
                  element[0] !== 'UnitId' &&
                  element[0] !== 'Unit' &&
                  element[0] !== 1
                ) {
                  element.category = element[0].split('#')[0];
                }
              });
              break;
            case 'Inspection Type':
              transposedArray[0].forEach((Name, index) => {
                if (index > 0) {
                  createSeries(index, Name, this.moduleValue);
                }
              });
              transposedArray.forEach((element) => {
                if (
                  element[0] !== 'Unit Name' &&
                  element[0] !== 'UnitId' &&
                  element[0] !== 1
                ) {
                  element.category = element[0];
                }
              });
              break;
            case 'Incident Type':
              transposedArray[0].forEach((Name, index) => {
                if (index > 0 && Name != 'Total') {
                  createSeries(index, Name, this.moduleValue);
                }
              });
              transposedArray.forEach((element) => {
                if (
                  element[0] !== 'Unit Name' &&
                  element[0] !== 'UnitId' &&
                  element[0] !== 1
                ) {
                  element.category = element[0];
                }
              });
              break;
          }
          //To get total on top of stack
          // let totalSeries = chart.series.push(new am4charts.ColumnSeries());
          // totalSeries.dataFields.valueY = "none";
          // totalSeries.dataFields.categoryX = "category";
          // totalSeries.stacked = true;
          // totalSeries.hiddenInLegend = true;
          // totalSeries.columns.template.strokeOpacity = 0;

          // var totalBullet = totalSeries.bullets.push(new am4charts.LabelBullet());
          // totalBullet.dy = -20;
          // totalBullet.label.text = "{valueY.total}";
          // totalBullet.label.hideOversized = false;
          // totalBullet.label.fontSize = 18;
          // totalBullet.label.background.fill = totalSeries.stroke;
          // totalBullet.label.background.fillOpacity = 0.2;
          // totalBullet.label.padding(5, 10, 5, 10);
        } else {
          createSeries('ContractorCount', 'Contractor Count', this.moduleValue);
        }
        break;
      default:
        createSeries('First', 'First', this.moduleValue);
        createSeries('Second', 'Second', this.moduleValue);
        chart.data = [
          {
            category: 'Unit1',
            First: 40,
            Second: 55,
          },
          {
            category: 'Unit2',
            First: 40,
            Second: 55,
          },
        ];
        break;
    }

    // Legend
    chart.legend = new am4charts.Legend();
    if (
      this.moduleValue == 'Observation Category' ||
      this.moduleValue == 'Incident Category' ||
      this.moduleValue == 'Inspection Type' ||
      this.moduleValue == 'Incident Type'
    ) {
      chart.legend.position = 'top';
    }

    // Enable Export
    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.menu.align = 'left';
    chart.exporting.menu.verticalAlign = 'top';
  }

  PieChart() {
    this.isShowZoomOut = true;

    var totalAssigned = 0;
    var pending = 0;
    var progress = 0;
    var complete = 0;
    var expired = 0;
    var rescheduled = 0;

    am4core.useTheme(am4themes_animated);

    let chart = am4core.create('chartdiv', am4charts.PieChart3D);
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    if (this.moduleValue == 'Training Compliance Summary') {
      if (this.data[0].Rows && this.data[0].Rows.length) {
        // chart.data = this.data[0].Rows;
        this.data[0].Rows.forEach((element) => {
          if (element[1] != 'Course Validity ( Year )') {
            if (element[1] == 'Total Assigned') {
              for (var i = 2; i < element.length; i++) {
                totalAssigned =
                  totalAssigned + (isNaN(element[i]) ? 0 : element[i]);
              }
            }
            if (element[1] == 'Pending for Approval') {
              for (var i = 2; i < element.length; i++) {
                pending = pending + (isNaN(element[i]) ? 0 : element[i]);
              }
            }
            if (element[1] == 'In Progress') {
              for (var i = 2; i < element.length; i++) {
                progress = progress + (isNaN(element[i]) ? 0 : element[i]);
              }
            }
            if (element[1] == 'Complete') {
              for (var i = 2; i < element.length; i++) {
                complete = complete + (isNaN(element[i]) ? 0 : element[i]);
              }
            }
            if (element[1] == 'Expired') {
              for (var i = 2; i < element.length; i++) {
                expired = expired + (isNaN(element[i]) ? 0 : element[i]);
              }
            }
            if (element[1] == 'Training Rescheduled') {
              for (var i = 2; i < element.length; i++) {
                rescheduled =
                  rescheduled + (isNaN(element[i]) ? 0 : element[i]);
              }
            }
          }
        });
      }
    }
    chart.data = [
      // {
      //   status: "Total Assigned",
      //   count: totalAssigned
      // },
      {
        status: 'Pending for Approval',
        count: pending,
      },
      {
        status: 'In Progress',
        count: progress,
      },
      {
        status: 'Complete',
        count: complete,
      },
      {
        status: 'Expired',
        count: expired,
      },
      {
        status: 'Training Rescheduled',
        count: rescheduled,
      },
    ];

    chart.innerRadius = am4core.percent(40);
    chart.depth = 120;

    chart.legend = new am4charts.Legend();
    chart.legend.position = 'top';

    var series = chart.series.push(new am4charts.PieSeries3D());
    series.dataFields.value = 'count';
    series.dataFields.depthValue = 'count';
    series.dataFields.category = 'status';
    series.slices.template.cornerRadius = 5;
    series.colors.step = 3;
    series.labels.template.text = '{status}: {count}';

    series.legendSettings.labelText = '{status}';
    series.legendSettings.valueText = '{count}';
  }

  TransposeData(data) {
    this.transposedData = data.reduce(function (arr, obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          arr[key] = arr[key] || [];
          arr[key].push(obj[key]);
        }
      }
      return arr;
    }, {});
  }
}
